// extracted by mini-css-extract-plugin
export default {"skip-menu-hidden":"SkipMenu__skip-menu-hidden__SyCzM","skip-menu-visible":"SkipMenu__skip-menu-visible__BvDxf","skip-menu":"SkipMenu__skip-menu__ifLNl"};